import React from 'react';
import { observer } from 'mobx-react';
import { Checkbox } from '@this/shared/ui/inputs/checkbox/checkbox';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@this/shared/ui/data_displays/table';
import type UserNotificationSetting from '@this/domain/user_notification_setting';
import {
  NOTIFICATION_CHANNELS,
  NOTIFICATION_CHANNEL_LABELS,
  NOTIFICATION_TARGETS,
  NOTIFICATION_TARGET_LABELS
} from '@this/domain/user_notification_setting';
import { Section, LeftLabel } from './user_edit';

type Props = {
  settings: UserNotificationSetting[];
};

export const NotificationSettings: React.FC<Props> = observer(({ settings }) => (
  <Section>
    <LeftLabel>通知設定</LeftLabel>
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell />
            {NOTIFICATION_CHANNELS.map(channel => (
              <TableCell key={channel}>{NOTIFICATION_CHANNEL_LABELS[channel]}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {NOTIFICATION_TARGETS.map(target => (
            <TableRow key={target}>
              <TableCell th>{NOTIFICATION_TARGET_LABELS[target]}</TableCell>
              {NOTIFICATION_CHANNELS.map(channel => {
                const setting = settings.find(s => s.target === target && s.channel === channel);
                return (
                  <TableCell key={channel}>
                    <Checkbox
                      checked={setting?.enabled ?? true}
                      onChange={() => {
                        if (setting) {
                          setting.enabled = !setting.enabled;
                        }
                      }}
                    />
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </Section>
));
